/** Тип платежа. */
export enum PaymentType {
    /** Предоплата. */
    Prepayment = "prepayment",

    /** Оплата. */
    Payment = "payment",
}
